<template>
  <div class="supervision_course_container">
    <div class="supervision_course_container_header">
      <!-- 左边的状态以及时间的展示： -->
      <div class="supervision_course_container_header_status_and_time">
        <picture-header-for-status
          :liveClassShareLiveInfo="liveClassShareLiveInfo"
          :liveDetailInfoForApp="liveDetailInfoForApp"
        ></picture-header-for-status>
      </div>
      <!-- 中间的头： -->
      <div class="supervision_course_container_header_title_module">
        <img src="https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202204/35556b7fa3124c9dba30a35274d4135d.png" alt="同步课堂网督学中心" />
      </div>
      <!-- 右边的网络状态： -->
      <div class="supervision_course_container_header_right_module">
        <!-- 网络状态： -->
        <network-info-of-status
          @lookForNetworkInfo="lookForNetworkInfo"
          :networkInfoStatus="networkInfoStatus"
          v-show="liveStatus == 1 && networkInfoStatus"
          :onNetworkQualityArr="onNetworkQualityArr"
          :networkInfoShow="networkInfoShow"
          :networkQualityStyle="{
            width: '200px',
            top: '30px',
            left: '-160px'
          }"
        />
      </div>
    </div>
    <div class="supervision_course_container_body">
      <div class="supervision_course_container_body_left">
        <!-- 课件画面： -->
        <div
          class="supervision_course_container_body_left_inner_for_screen_stream"
          :style="{ zIndex: lookForCourseScreen ? 1 : 0 }"
        >
          <video src="" id="idForCourseScreenOnLeft" autoplay></video>
          <div class="play_explain_for_box" style="color: #FFF">
            课件画面(主讲)
          </div>
        </div>
        <!-- 教室画面： -->
        <div
          class="supervision_course_container_body_left_inner_for_class_of_outer"
          :style="{ zIndex: lookForCourseScreen ? 0 : 1 }"
        >
          <video src="" id="videoForClassroomOnLeft" autoplay muted></video>
          <div class="play_explain_for_box"
            :style="{ color: '#FFF' }">
            {{ playExplainForBoxTitle }}
          </div>
          <div class="video_empty_container" v-show="liveStatus != 0  && liveStatus != 1">
            <span class="iconfont icon-zanwuxinxi"></span>
            <span>{{ liveStatus | disposeLiveStatus }}</span>
          </div>
        </div>
        <!-- 调整机位： -->
        <vidicon-control v-if="activeForOperationItem === 'adjust'" :currentPlayItem="currentPlayItem" :clientForZRTC="clientForZRTC" />
      </div>
      <div class="supervision_course_container_body_right">
        <!-- 右侧栏与视频相关： -->
        <template>
          <div class="supervision_course_container_body_right_for_video" :style="{ alignItems: videoList.length > 2 ? 'flex-start' : 'center' }">
            <div class="supervision_course_container_body_right_inner">
              <!-- 主讲教室： -->
              <template v-for="item in videoList">
                <div
                  :class="[
                    'supervision_course_container_body_right_inner_item',
                    item.active ? 'active' : '',
                    'ZHIHUISHU_QZMD',
                  ]"
                  :key="item.roomName"
                  @click="operationOfClickVideoListInnerItem(item)"
                  v-if="(item.userRole === ROLE.SPEAKER)"
                >
                  <!-- 教室画面：主讲：这里产品要求主讲一定要放第一个 -->
                  <div
                    class="supervision_course_container_body_right_inner_item_for_video classroom_in_list_on_right_outer"
                  >
                    <video
                      src=""
                      autoplay
                      muted
                      :id="`video${item.roomId}`"
                    ></video>
                    <!-- 音频单独加： -->
                    <audio
                      src=""
                      autoplay
                      controls
                      :id="`audio${item.roomId}`"
                    ></audio>
                  </div>
                  <div
                    class="play_explain_for_box ZHIHUISHU_QZMD"
                    :style="{ color: '#FFF' }"
                    @click="operationOfClickVideoListInnerItem(item)"
                  >
                    <span>
                      {{ ((item.currentVideoDevice || [])[0] || {}).mediaLabel === 'classroom' ? (`${item.userName}` + (item.roomName ? '-': '') + `${item.roomName}`) : item.userName || '' }}(主讲)
                    </span>
                    <microphone-icon v-if="item.speaking" :barHeightForAudio="item.barHeightForAudio || '0%'" />
                  </div>
                </div>
              </template>
              <!-- 课件画面： -->
              <div
                :class="[
                  'supervision_course_container_body_right_inner_item',
                  lookForCourseScreen ? 'active' : '',
                ]"
                v-if="showForCourseScreenInListOnRight"
              >
                <!-- 课件画面：（有课件才会展示） -->
                <div
                  class="supervision_course_container_body_right_inner_item_for_video course_screen_in_list_on_right_outer ZHIHUISHU_QZMD"
                  @click="operationOfClickCourseScreen()"
                >
                  <video
                    src=""
                    id="idForCourseScreenInListOnRight"
                    autoplay
                    muted
                    :style="{objectFit: 'fill'}"
                  ></video>
                </div>
                <div
                  class="play_explain_for_box ZHIHUISHU_QZMD"
                  style="color: #FFF"
                  @click="operationOfClickCourseScreen()"
                >
                  课件画面(主讲)
                </div>
              </div>
              <!-- 听课教室： -->
              <template v-for="item in videoList">
                <div
                  :class="[
                    'supervision_course_container_body_right_inner_item',
                    item.active ? 'active' : '',
                    'ZHIHUISHU_QZMD',
                  ]"
                  :key="item.roomName"
                  @click="operationOfClickVideoListInnerItem(item)"
                  v-if="(item.userRole === ROLE.LISTENER)"
                >
                  <!-- 教室画面：主讲：这里产品要求主讲一定要放第一个，收视放在课件画面 -->
                  <div
                    class="supervision_course_container_body_right_inner_item_for_video classroom_in_list_on_right_outer"
                  >
                    <!-- flv替换成了webrtc: -->
                    <video
                      src=""
                      autoplay
                      muted
                      :id="`video${item.roomId}`"
                    ></video>
                    <!-- 音频单独加： -->
                    <audio
                      src=""
                      autoplay
                      controls
                      :id="`audio${item.roomId}`"
                    ></audio>
                  </div>
                  <div
                    class="play_explain_for_box ZHIHUISHU_QZMD"
                    :style="{ color: '#FFF' }"
                    @click="operationOfClickVideoListInnerItem(item)"
                  >
                    <span>
                      {{ ((item.currentVideoDevice || [])[0] || {}).mediaLabel === 'classroom' ? (`${item.userName}` + (item.roomName ? '-': '') + `${item.roomName}`) : item.userName || '' }}(听课)
                    </span>
                    <microphone-icon v-if="item.speaking" :barHeightForAudio="item.barHeightForAudio || '0%'" />
                  </div>
                  <div style="color: #fff">{{ item }}</div>
                </div>
              </template>
              <!-- 学生： -->
              <template v-for="item in videoList">
                <div
                  :class="[
                    'supervision_course_container_body_right_inner_item',
                    item.active ? 'active' : '',
                    'ZHIHUISHU_QZMD',
                  ]"
                  :key="item.roomName"
                  @click="operationOfClickVideoListInnerItem(item)"
                  v-if="(item.userRole === ROLE.STUDENT)"
                >
                  <!-- 教室画面：主讲：这里产品要求主讲一定要放第一个，收视放在课件画面 -->
                  <div
                    class="supervision_course_container_body_right_inner_item_for_video classroom_in_list_on_right_outer"
                  >
                    <!-- flv替换成了webrtc: -->
                    <video
                      src=""
                      autoplay
                      muted
                      :id="`video${item.roomId}`"
                    ></video>
                    <!-- 音频单独加： -->
                    <audio
                      src=""
                      autoplay
                      controls
                      :id="`audio${item.roomId}`"
                    ></audio>
                  </div>
                  <div
                    class="play_explain_for_box ZHIHUISHU_QZMD"
                    :style="{ color: '#FFF' }"
                    @click="operationOfClickVideoListInnerItem(item)"
                  >
                    <span>{{ item.userName }}</span>
                    <microphone-icon v-if="item.speaking" :barHeightForAudio="item.barHeightForAudio || '0%'" />
                  </div>
                  <div style="color: #fff">{{ item }}</div>
                </div>
              </template>
            </div>
            <div class="empty_for_class_rooom_list" v-if="!videoList.length && !showForCourseScreenInListOnRight">
              <span class="iconfont icon-zanwushuju"></span>
              抱歉，暂无教室哦
            </div>
          </div>
        </template>
        <!-- 右侧栏与详情相关： -->
        <template v-if="activeForOperationItem === 'classroom'">
          <div class="live_detail_container">
            <div class="live_detail_container_title">直播+教室详情</div>
            <div class="live_detail_container_base_info">
              <div class="live_detail_container_base_info_title">基本信息</div>
              <div class="live_detail_container_base_info_body">
                <div
                  class="live_detail_container_base_info_body_item"
                  v-for="item in objectOfLCDetail.detailInfoList"
                  :key="item.title"
                >
                  <div class="live_detail_container_base_info_body_item_title">
                    【{{ item.title }}】：
                  </div>
                  <div class="live_detail_container_base_info_body_item_body">
                    <a-tooltip placement="topLeft" :overlayStyle="{width: 'auto'}">
                      <template slot="title">
                        <span>{{item.firstValue ? item.firstValue : '- -'}}</span>
                        <span v-if="item.hasOwnProperty('secondValue')">（{{item.secondValue ? item.secondValue : '- -'}}）</span>
                      </template>
                      <span :class="['first_value']">{{
                        item.firstValue ? item.firstValue : '- -'
                      }}</span>
                      <span
                        class="second_value"
                        v-if="item.hasOwnProperty('secondValue')"
                        >（{{
                          item.secondValue ? item.secondValue : '- -'
                        }}）</span
                      >
                    </a-tooltip>
                  </div>
                </div>
              </div>
            </div>
            <div class="live_detail_container_for_teacher">
              <div class="live_detail_container_for_teacher_title">
                主讲
              </div>
              <div class="live_detail_container_for_teacher_body" v-if="teacherRoomNum">
                <div
                  class="body_item"
                  v-for="item in objectOfLCDetail.roomList"
                  :key="item.roomName"
                  v-show="item.roomType === 1"
                >
                  <div class="body_item_title">
                    {{ item.roomName }}
                  </div>
                  <div class="body_item_body">
                    <div class="body_item_body_management">
                      <span class="person_type"
                        >{{
                          item.classType ? '【导播】' : '【管理员】'
                        }}：</span
                      >
                      <span class="person_name">{{
                        item.adminName ? item.adminName : '- -'
                      }}</span>
                      <span class="person_phone"
                        >（{{
                          item.adminPhone ? item.adminPhone : '- -'
                        }}）</span
                      >
                    </div>
                    <div class="body_item_body_maintain">
                      <span class="person_type"
                        >{{
                          item.classType ? '【专员】' : '【维护员】'
                        }}：</span
                      >
                      <span class="person_name">{{
                        item.defendName ? item.defendName : '- -'
                      }}</span>
                      <span class="person_phone"
                        >（{{
                          item.defendPhone ? item.defendPhone : '- -'
                        }}）</span
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div class="live_detail_container_for_teacher_body_empty" v-if="!teacherRoomNum">
                抱歉，暂无教室哦
              </div>
            </div>
            <div class="live_detail_container_for_student">
              <div class="live_detail_container_for_student_title">
                听课（{{ watchRoomNum }}）
              </div>
              <div class="live_detail_container_for_student_body" v-if="watchRoomNum">
                <div
                  class="body_item body_item_for_student"
                  v-for="item in objectOfLCDetail.roomList"
                  :key="item.roomName"
                  v-show="item.roomType === 2"
                >
                  <div class="body_item_title">
                    {{ item.roomName }}
                  </div>
                  <div class="body_item_body">
                    <div class="body_item_body_management">
                      <span class="person_type"
                        >{{
                          item.classType ? '【导播】' : '【管理员】'
                        }}：</span
                      >
                      <span class="person_name">{{
                        item.adminName ? item.adminName : '- -'
                      }}</span>
                      <span class="person_phone"
                        >（{{
                          item.adminPhone ? item.adminPhone : '- -'
                        }}）</span
                      >
                    </div>
                    <div class="body_item_body_maintain">
                      <span class="person_type"
                        >{{
                          item.classType ? '【专员】' : '【维护员】'
                        }}：</span
                      >
                      <span class="person_name">{{
                        item.defendName ? item.defendName : '- -'
                      }}</span>
                      <span class="person_phone"
                        >（{{
                          item.defendPhone ? item.defendPhone : '- -'
                        }}）</span
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div class="live_detail_container_for_student_body_empty" v-if="!watchRoomNum">
                抱歉，暂无教室哦
              </div>
            </div>
          </div>
        </template>
        <!-- 右侧与文字互动相关： -->
        <template v-if="activeForOperationItem === 'textInteraction'">
          <div class="textInteraction_container">
            <chat-room />
          </div>
        </template>
      </div>
      <!-- 右侧装饰块，只有详情和聊天室展示这个： -->
      <div class="supervision_course_container_body_right_top_module" v-if="activeForOperationItem === 'classroom' || activeForOperationItem === 'textInteraction'"></div>
    </div>
    <div class="supervision_course_container_footer">
      <div class="supervision_course_container_footer_left_for_name">
        {{
          liveClassShareLiveInfo && liveClassShareLiveInfo.liveName
            ? liveClassShareLiveInfo.liveName
            : '- -'
        }}
      </div>
      <div class="supervision_course_container_footer_right_for_operation">
        <div
          :class="[
            'supervision_course_container_footer_right_for_operation_item ZHIHUISHU_QZMD',
            activeForOperationItem === item.key ? 'active' : '',
            item.disabled ? 'class_for_disabled' : ''
          ]"
          v-for="item in operationList"
          :key="item.key"
          @click.stop="operationOfClickButton(item)"
        >
          <img v-if="getIsHaveNewMsg && item.key == 'textInteraction'" class="iconfont_icon" src="../../assets/img/icon_student_web.png" :alt="item.title" />
          <img v-else class="iconfont_icon" :src="item.img" :alt="item.title" />
          <span class="iconfont_text" :style="{ color: item.color }">
            {{ item.title}}
            <span v-if="item.key === 'classroom'">({{ Number(watchRoomNum) + Number(teacherRoomNum) }})</span>
          </span>
        </div>
      </div>
    </div>
    <!-- 终止直播： -->
    <my-dialog
      @hideMask="hideMaskForStopLiveCourse"
      :dialogFlag="dialogFlagForStopLiveCourse"
      width="396px"
      p_lr="0"
      borderRadius="8px"
      :hideMaskFlag="false"
    >
      <div class="dialog_inner_container_for_stop_live_course">
        <div class="dialog_inner_container_for_stop_live_course_header">
          终止直播！
        </div>
        <div class="dialog_inner_container_for_stop_live_course_body">
          <div class="dialog_inner_container_for_stop_live_course_body_title">
            确认要“终止直播”么？终止后，所有听课教室将无法继续听课，如有问题可先联系“智慧树”客服
          </div>
          <div
            :class="[
              'dialog_inner_container_for_stop_live_course_body_content',
              'animate__animated',
              stopReasonHasAnimateShakeX ? 'animate__shakeX' : '',
            ]"
          >
            <textarea
              type="textarea"
              v-model="stopReason"
              placeholder="请输入强行终止直播的原因，如课堂涉黄、涉恐等..."
            ></textarea>
          </div>
        </div>
        <div class="dialog_inner_container_for_stop_live_course_footer">
          <div
            :class="[
              'dialog_inner_container_for_stop_live_course_footer_inner_item ZHIHUISHU_QZMD',
              stopLiveCourseOperationItem.className,
            ]"
            v-for="stopLiveCourseOperationItem in stopLiveCourseOperationList"
            :key="stopLiveCourseOperationItem.title"
            :style="{
              backgroundColor: stopLiveCourseOperationItem.bgc,
              border: stopLiveCourseOperationItem.border,
              color: stopLiveCourseOperationItem.color,
            }"
            @click="operationForStopLiveCourseItem(stopLiveCourseOperationItem)"
          >
            {{ stopLiveCourseOperationItem.title }}
          </div>
        </div>
        <div class="loading_mask" v-if="dialogLoadingForStopLiveCourse">
          <a-spin />
        </div>
      </div>
    </my-dialog>
    <!-- 播放按钮： -->
    <play-button @operationForPlay="operationForPlay" v-if="autoPlayError" />
  </div>
</template>

<script>
import { mapMutations, mapGetters, mapActions } from 'vuex'
import LivePlayer from '@liveqing/liveplayer'
import DateUtil from '../../utils/getDate.js'
import { getRandomNumber, getNameTextForEnumeration } from '../../utils/tool.js'
import Agora from '../../utils/agora.js'
import { hintByliveStatusOptions } from '../../utils/enumerate.js'
const SOCKET_MSG_TYPE = {
  USER_LIST_ON_MIC: 'base-onmic-users', // 在麦用户列表
  USER_PUBLISHED: 'user-published', // 流发布
  USER_UNPUBLISHED: 'user-unpublished', // 取消流发布
  USER_UPDATE: 'base-onmic-users-updated', // 用户变更
  LIVE_STATUS_UPDATE: 'base-live-status-updated', // 直播状态变更
  LAST_INFO_DETAIL: 'base-action-info', // 终端快照
  VOLUME_INDICATOR: 'volume-indicator', // 流音量变化
  // OPEN_SHARE_SCREEN: '4041', // 开启共享屏幕
  // CLOSE_SHARE_SCREEN: '4042', // 关闭屏幕共享
  // LISTEN_TEACHER_JOIN: '4039', // 听课老师教室新增
  // LISTEN_TEACHER_EXIT: '4007', // 听课老师教室退出
  // STU_MICROPHONE_ON_OFF: 'studentMike', // 学生上下麦
  // END_CLASS: '4004', // 下课指令
  // CLASSROOM_CAMERA: '4043', // 切换摄像头画面
}
const ROLE = {
  SPEAKER: 1, // 主讲
  LISTENER: 2, // 听课
  STUDENT: 3, // 学生
  SHARE_SCREEN: 99 // 共享屏幕, 服务端没有共享屏幕role,此为前端维护字段
}
export default {
  name: 'SupervisionCourse',
  components: {
    'live-player': LivePlayer,
    'detail-by-liveId': () => import('../../components/componentsForPage/detail_by_liveId'),
    'my-dialog': () => import('../../components/my_dialog'),
    'picture-header-for-status': () => import('../../components/componentsForPage/picture_header_for_status'),
    'network-info-of-status': () => import('../../components/networkInfoOfStatus/index.vue'),
    'vidicon-control': () => import('../../components/vidiconControl/index.vue'),
    'microphone-icon': () => import('../../components/microphoneIcon/index.vue'),
    'chat-room': () => import('../../components/chatRoom/index.vue'),
    'play-button': () => import('../../components/playButton/index.vue')
  },
  data() {
    return {
      // 直播详情：
      liveClassShareLiveInfo: null,
      // socket相关：
      websocketUrl: '',
      websocket: null,
      websocketStatus: '',
      lcId: '',
      socketInitTimeerId: null,
      // 播放相关：
      videoList: [],
      currentPlayItem: null,
      // 底部操作按钮：
      operationList: [
        {
          title: '教室',
          icon: 'icon-caiyouduo_hemaixiangqing-fanganxiangqing',
          img: 'https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202204/33136bf13cc44d28b0202cd9a64f7e4f.png',
          imgWhite: 'https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202204/33136bf13cc44d28b0202cd9a64f7e4f.png',
          imgGray: 'https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202303/4e592cca26504d3ebf8aa0b4dbd06a51.png',
          key: 'classroom',
          color: '#FFF',
          disabled: false
        },
        {
          title: '调整机位',
          icon: '',
          img: 'https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202204/20c97caea47a443e87fb7df90a590137.png',
          imgWhite: 'https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202204/20c97caea47a443e87fb7df90a590137.png',
          imgGray: 'https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202204/f8b4052cf0734d849c9e25e0271adb34.png',
          key: 'adjust',
          color: '#FFF',
          disabled: false
        },
        {
          title: '文字互动',
          icon: '',
          img: 'https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202303/64866f1c611e4e1f84fdb1f2c8b44cbe.png',
          imgWhite: 'https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202204/d7dcf58dbec84b3bb6107403625a8184.png',
          imgGray: 'https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202303/64866f1c611e4e1f84fdb1f2c8b44cbe.png',
          key: 'textInteraction',
          color: '#555B62',
          disabled: true
        },
        {
          title: '终止直播',
          icon: 'icon-zuizhongchuqu',
          img: 'https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202303/58a82f31ba304390afaafb8f8f13ade2.png',
          imgWhite: 'https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202204/fba5009825f749a7af2f1b860fbfdcc2.png',
          imgGray: 'https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202303/58a82f31ba304390afaafb8f8f13ade2.png',
          key: 'termination',
          color: '#555B62',
          disabled: true
        },
      ],
      activeForOperationItem: '',
      // lc detail:
      // dialogFlagForLCDetail: false,
      objectOfLCDetail: {
        detailInfoList: [
          {
            title: '课程',
            firstValue: '',
            secondValue: '',
            secondColor: '#669CFF',
          },
          {
            title: '类型',
            firstValue: '同步课堂',
            secondValue: '',
            secondColor: '##474C59',
          },
          {
            title: '主讲',
            firstValue: '',
            secondValue: '',
            secondColor: '#669CFF',
          },
          {
            title: '时间',
            firstValue: '',
          },
        ],
        roomList: [],
      },
      dialogLoadingForLCDetail: false,
      // 终止直播：
      stopReason: '',
      stopReasonHasAnimateShakeX: false,
      dialogFlagForStopLiveCourse: false,
      stopLiveCourseOperationList: [
        {
          title: '继续终止',
          bgc: 'transparent',
          border: '1px solid #858688',
          color: '#FAFAFA',
          className: 'stop_live_course_continue',
        },
        {
          title: '撤销操作',
          bgc: '#3982FF',
          border: 'none',
          color: '#FFF',
          className: 'stop_live_course_cancel',
        },
      ],
      dialogLoadingForStopLiveCourse: false,
      // 共享屏幕：
      myAgora: null,
      agorartcInfo: null,
      role: 2, // 主讲助教：1主讲2助教
      isJoined: false, // 判断是否拿到课件流
      // 左侧课件的展示与播放：
      lookForCourseScreen: false,
      // 右侧课件画面是否展示：
      showForCourseScreenInListOnRight: false,
      // 左侧教室的切换优化：
      livePlayerShow: true,
      // webrtc订阅相关：
      streamMap: new Map(), // 保存订阅到的音频或者视频流
      clientForZRTC: null,
      preAudioStreamIdList: [], // 前一次的所有的流id
      preVideoStreamIdList: [], // 前一次的所有的流id

      // 指标展示：
      networkInfoShow: false,
      // 及时更新的：
      onNetworkQualityObjStatus: '',
      onNetworkQualityArrOrigin: [
        {
          key: 'WebRTCDelay',
          value: '',
          title: '延迟',
          unit: 'ms'
        },
        {
          key: 'packetsLostRate',
          value: '',
          title: '丢包率',
          unit: '%'
        }
      ],
      // 间隔更新的：
      networkInfoStatus: '',
      onNetworkQualityArr: [],
      // 麦克风音量：
      // barHeightForAudio: '0%',
      // 针对自动播放：
      autoPlayError: false,
      // 后面新增的详情：
      liveDetailInfoForApp: null,
      // 是否监听了消息：
      listenedOnSignalMessage: false,
      socketMsg: {},
      ROLE
    }
  },
  filters: {
    disposeLiveStatus: function (liveStatus) {
      return getNameTextForEnumeration(hintByliveStatusOptions, liveStatus)
    },
  },
  computed: {
    ...mapGetters('userInfo', ['userId', 'userInfo']),
    ...mapGetters('imCommunication', ['getLeftBarName', 'getIsHaveNewMsg']),
    // 直播详情：有几间收视教室
    watchRoomNum() {
      return this.objectOfLCDetail.roomList.filter(
        (item) => item.roomType === 2
      ).length
    },
    teacherRoomNum() {
      return this.objectOfLCDetail.roomList.filter(
        (item) => item.roomType === 1
      ).length
    },
    liveStatus() {
      let num = -3
      if (this.liveClassShareLiveInfo) {
        let { status } = this.liveClassShareLiveInfo
        num = status
      }
      return num
    },
    playExplainForBoxTitle () {
      let res = '- -'
      if (!this.currentPlayItem) return res
      const { userRole } = this.currentPlayItem
      switch (userRole) {
        case ROLE.SPEAKER:
        case ROLE.LISTENER:
          res = (((this.currentPlayItem.currentVideoDevice || [])[0] || {}).mediaLabel === 'classroom' ? (`${this.currentPlayItem.userName}` + (this.currentPlayItem.roomName ? '-': '') + `${this.currentPlayItem.roomName}`) : this.currentPlayItem.userName || '') + `(${userRole === ROLE.SPEAKER ? '主讲' : '听课'})`
          break
        case ROLE.STUDENT:
          res = this.currentPlayItem.userName
          break
      }
      return res
    }
  },
  watch: {
    currentPlayItem: {
      handler: function (newval) {
        // 左侧教室画面展示：
        if (newval) {
          this.operationOfDOM(true)
        }
        // 新增逻辑：
        let flagForDisabled = false
        if (newval) {
          flagForDisabled = false
        } else {
          flagForDisabled = true
        }
        if (this.lookForCourseScreen) {
          flagForDisabled = true
        }
        // this.disposeForAdjustDisabled(flagForDisabled)
        // 默认要置灰：
        this.disposeForAdjustDisabled(true)
      },
      immediate: true,
      deep: true,
    },
    socketMsg: {
      handler: function (newVal) {
        this.dealSocketMsg(newVal)
      }
    }
  },
  async created() {
    try {
      let { liveId } = this.$route.query
      if (!liveId) return this.$router.go(-1)
      // 获取到详情：
      const resultLiveInfo = await this.$http.getLiveInfoGlobalMSC2({ liveId })
      console.log(resultLiveInfo, 'resultLiveInfo')
      // 获取到教室列表：
      // const resultClassRoomList = await this.$http.getClassRoomListGlobal({ liveId })
      // console.log(resultClassRoomList, 'resultClassRoomList')
      // const joinStreamRoomList = Object.values(resultClassRoomList.rt || {})
      // // 设置当前正在播放的教室：
      // if (!this.currentPlayItem) {
      //   console.log(joinStreamRoomList, 'joinStreamRoomList')
      //   this.currentPlayItem = joinStreamRoomList[0] ? joinStreamRoomList[0] : null
      // }
      // // 设置教室列表：
      // this.videoList = joinStreamRoomList
      // if (this.currentPlayItem) {
      //   // 设置高亮选中效果：
      //   this.videoList = this.videoList.map((item) => {
      //     if (item.roomId === this.currentPlayItem.roomId) {
      //       item.active = true
      //     } else {
      //       item.active = false
      //     }
      //     // 同时设置发言状态：默认为主讲
      //     if (item.userRole == ROLE.SPEAKER) {
      //       item.speaking = true
      //     } else {
      //       item.speaking = false
      //     }
      //     return item
      //   })
      // }
      // 初始化SDK：
      let client = null
      if (!this.clientForZRTC) {
        client = await this.ZRTCInit()
        this.clientForZRTC = client
      } else {
        client = this.clientForZRTC
      }
      this.getSocketMessage()
      // 需要拉到所有的流：
      // this.initForStream(this.videoList)
      this.getLCDetail(this.$route.query.liveId)
      await this.liveClassShareLive()
      this.liveDetailInfoForApp = await this.getLiveDetailForAPP(this.$route.query.liveId)
      console.log(this.liveDetailInfoForApp, 'liveDetailInfoForApp')
    } catch (err) {
      console.log(err)
    }
  },
  mounted() {
    // 应产品要求，每5秒钟更新一次网络监测信息：
    const timerIdForUpdateNetworkInfo = setInterval(() => {
      this.onNetworkQualityArr = JSON.parse(
        JSON.stringify(this.onNetworkQualityArrOrigin)
      )
      this.networkInfoStatus = this.onNetworkQualityObjStatus
    }, 5000)
    this.$once('hook:beforeDestroy', () => {
      this.clientForZRTC && this.clientForZRTC.leaveRoom()
      timerIdForUpdateNetworkInfo && clearInterval(timerIdForUpdateNetworkInfo)
    })
  },
  methods: {
    ...mapMutations('userInfo', {
      Mutation_SET_USERID: 'Mutation_SET_USERID',
    }),
    ...mapMutations('imCommunication', {
      addIMMsg: 'addIMMsg',
      setIsHaveNewMsg: 'setIsHaveNewMsg',
      setRoleList: 'setRoleList'
    }),
    ...mapActions('imCommunication', {
      getImConfigInfo: 'getImConfigInfo',
      webImInit: 'webImInit',
    }),
    // 通过liveId获取的直播信息：
    async liveClassShareLive() {
      // let { data: result } = await this.$http.liveClassShareLive({
      //   liveId: this.$route.query.liveId,
      // })
      // 换为新接口：
      let result = await this.$http.getLiveInfoGlobalMSC2({
        liveId: this.$route.query.liveId,
      })
      if (result.code !== 200) return this.$message.error(result.msg)
      this.liveClassShareLiveInfo = result.rt
    },
    // 获取sockt消息：
    getSocketMessage() {
      const self = this
      if (self.listenedOnSignalMessage) return
      this.clientForZRTC.onSignalMessage(data => {
        self.listenedOnSignalMessage = true
        self.socketMsg = data.response
      })
    },
    ZRTCInit() {
      return new Promise(async (resolve) => {
        const client = ZRTC2.init(this.$route.query.liveId)
        client.setClientRole('audience')
        try {
          await client.joinAudienceRoom()
          console.log('joinRoom success')
          resolve(client)
          client.onSignalMessage(data => {
            self.listenedOnSignalMessage = true
            self.socketMsg = data.response
          })
        } catch (err) {
          console.log(err, 'joinRoom_err')
          return this.$message.error(
            '抱歉，当前加入直播人数已达上限，无法加入！'
          )
        }
      })
    },
    async initForStream(newval) {
      // 获取音视频流列表：
      const audioStreamIdList = []
      const videoStreamIdList = []
      newval.forEach(item => {
        (item.currentAudioDevice || []).forEach(v => {
          if (v.streamId) audioStreamIdList.push(v.streamId)
        })
        ;(item.currentVideoDevice || []).forEach(v => {
          if (v.streamId) videoStreamIdList.push(v.streamId)
        })
      })
      // 获取差集：
      const intersectionForAudioStreamId = audioStreamIdList.filter(item => !new Set(this.preAudioStreamIdList).has(item))
      const intersectionForVideoStreamId = videoStreamIdList.filter(item => !new Set(this.preVideoStreamIdList).has(item))
      this.preAudioStreamIdList = audioStreamIdList
      this.preAudioStreamIdList = videoStreamIdList
      // 监听流来了：
      console.log(intersectionForAudioStreamId, 'intersectionForAudioStreamId')
      console.log(intersectionForVideoStreamId, 'intersectionForVideoStreamId')
      // this.clientForZRTC.onRemoteStream(obj => {
      //   if (obj.code === ZRTC.CODE.RSComing) {
      //     this.streamMap.set(obj.streamId, obj.responseData.stream)
      //     this.operationOfDOM()
      //     console.log(this.streamMap, 'streamMap_Map')
      //   }
      // })
      // 只订阅没有订阅过的流：
      for (let i = 0, len = intersectionForAudioStreamId.length; i < len; i++) {
        (async (i) => {
          try {
            console.log(intersectionForAudioStreamId[i], 'intersectionForAudioStreamId[i]--订阅此流id')
            const res = await this.clientForZRTC.subscribe(intersectionForAudioStreamId[i], 'audio')
            console.log(res, 'intersectionForAudioStreamId[i]_res')
            this.streamMap.set(res.streamId, res)
            this.operationOfDOM()
          } catch (err) {
            console.log(err, 'errSubscribeStream')
          }
        })(i)
      }
      for (let i = 0, len = intersectionForVideoStreamId.length; i < len; i++) {
        (async (i) => {
          try {
            console.log(intersectionForVideoStreamId[i], 'intersectionForVideoStreamId[i]--订阅此流id')
            const res = await this.clientForZRTC.subscribe(intersectionForVideoStreamId[i])
            console.log(res, 'intersectionForVideoStreamId[i]_res')
            this.streamMap.set(res.streamId, res)
            this.operationOfDOM()
          } catch (err) {
            console.log(err, 'errSubscribeStream')
          }
        })(i)
      }
      let updateCount = 0
      // 网络质量：
      this.clientForZRTC.onNetworkQuality((data) => {
        console.log(data, 'onNetworkQuality_data')
        const onNetworkQualityObj = data
        // 检测web rtc实时音量 跳动展示
        // if (data.kind == 'audio') {
          // let volume =  (data.audioLevel * 100 / 15).toFixed(0)
          // this.barHeightForAudio = (volume * 15 > 100 ? 100 : volume * 15) + '%'
          // 教室列表的麦克风动态音量效果*2：
          // this.barHeightForAudio = (volume * 15 > 100 ? 100 : volume * 15 * 2) + '%'
        // }
        if (onNetworkQualityObj.kind !== 'video') return
        this.onNetworkQualityArrOrigin = this.onNetworkQualityArrOrigin.map(
          (item) => {
            item.value = onNetworkQualityObj[item.key]
              ? onNetworkQualityObj[item.key]
              : 0
            return item
          }
        )
        // console.log(onNetworkQualityObj.stats, 'onNetworkQualityObj.stats')
        if (onNetworkQualityObj.stats !== '无数据') {
          this.onNetworkQualityObjStatus = onNetworkQualityObj.stats
        }

        // 以下只更新一次：
        if (updateCount === 0) {
          updateCount++
          this.onNetworkQualityArr = JSON.parse(
            JSON.stringify(this.onNetworkQualityArrOrigin)
          )
          this.networkInfoStatus = this.onNetworkQualityObjStatus
        }
      })
      // 获取在麦状态：
      // this.clientForZRTC.onGetMicStatus(data => {
      //   console.log(data, 'onGetMicStatus_data')
      //   // console.log(data.responseData, 'data.responseData')
      //   console.log(data.responseData.content || [], 'data.responseData.content')
      //   if (data.responseData && data.responseData.content || []) {
      //     const roomIds = (data.responseData.content || []).filter(item => item.voice).map(item => item.roomid)
      //     this.videoList = this.videoList.map(item => {
      //       if (roomIds.includes(item.roomId)) {
      //         item.speaking = true
      //       } else {
      //         item.speaking = false
      //       }
      //       return item
      //     })
      //   }
      // })
    },
    operationOfDOM(onlyDisposeLeft) {
      try {
        this.$nextTick(async () => {
          if (!onlyDisposeLeft) {
            // 右侧列表的画面声音全部展示：
            this.videoList.forEach(async v => {
              const videoForClassroomOnRight = document.querySelector(`#video${v.roomId}`)
              console.log(videoForClassroomOnRight, 'videoForClassroomOnRightvideoForClassroomOnRight')
              // 获取当前需要展示的视频流id:
              // const videoStreamId = ((v.videoStreams || []).filter(vv => vv.bindClient === v.currentVideoDevice)[0] || { streamId: '' }).streamId
              const videoStreamId = (v.currentVideoDevice[0] || { streamId: '' }).streamId
              if (videoForClassroomOnRight) {
                if (videoForClassroomOnRight.srcObject !== this.streamMap.get(videoStreamId)) {
                  videoForClassroomOnRight.srcObject = this.streamMap.get(videoStreamId)
                }
              }
              const audioForClassroomOnRight = document.querySelector(`#audio${v.roomId}`)
              let mediastreamForAudio = new MediaStream()
              ;(v.currentAudioDevice || []).forEach(vv => {
                const audioStream = this.streamMap.get(vv.streamId)
                if (audioStream) {
                  const tracks = audioStream.getTracks()
                  console.log(tracks, 'tracks_tracks')
                  tracks.forEach(track => {
                    mediastreamForAudio.addTrack(track)
                  })
                }
              })
              audioForClassroomOnRight && (audioForClassroomOnRight.srcObject = mediastreamForAudio)
              // 处理音频的自动播放：
              if (audioForClassroomOnRight && mediastreamForAudio) {
                try {
                  await audioForClassroomOnRight.play()
                  this.autoPlayError = false
                } catch (err) {
                  console.log(err, 'autoplayError')
                  // 需要弹出播放按钮：
                  if (String(err).includes('first')) {
                    this.autoPlayError = true
                  } else {
                    this.autoPlayError = false
                  }
                }
              }
              // new：音频流改造之后，每一个教室的音频流id是数组（20220531 end）
            })
          }
          // 左侧教室画面展示：
          const videoForClassroomOnLeft = document.querySelector(`#videoForClassroomOnLeft`)
          if (this.currentPlayItem) {
            // const videoStreamIdCurrentPlayItem = (this.currentPlayItem.videoStreams.filter(vv => vv.bindClient === this.currentPlayItem.currentVideoDevice)[0] || { streamId: '' }).streamId
            const videoStreamIdCurrentPlayItem = (this.currentPlayItem.currentVideoDevice[0] || { streamId: '' }).streamId
            if (videoForClassroomOnLeft.srcObject !== this.streamMap.get(videoStreamIdCurrentPlayItem)) {
              videoForClassroomOnLeft.srcObject = this.streamMap.get(videoStreamIdCurrentPlayItem)
            }
          }
          // 共享屏幕相关的：
          const shareScreenItem = this.videoList.find(item => item.userRole === ROLE.SHARE_SCREEN)
          if (shareScreenItem) {
            this.showForCourseScreenInListOnRight = true
            if (document.querySelector('#idForCourseScreenInListOnRight') && (document.querySelector('#idForCourseScreenInListOnRight').srcObject !== this.streamMap.get(shareScreenItem.videoStreamId))) {
              document.querySelector('#idForCourseScreenInListOnRight').srcObject = this.streamMap.get(shareScreenItem.videoStreamId)
            }
            if (document.querySelector('#idForCourseScreenOnLeft') && (document.querySelector('#idForCourseScreenOnLeft').srcObject !== this.streamMap.get(shareScreenItem.videoStreamId))) {
              document.querySelector('#idForCourseScreenOnLeft').srcObject = this.streamMap.get(shareScreenItem.videoStreamId)
            }
          } else {
            this.showForCourseScreenInListOnRight = false
          }
        })
      } catch (err) {
        console.log(err, 'errOperationOfDOM')
      }
    },
    // 处理音频的自动播放：
    operationForPlay () {
      this.videoList.forEach(v => {
        const audioForClassroomOnRight = document.querySelector(`#audio${v.roomId}`)
        audioForClassroomOnRight && audioForClassroomOnRight.play()
      })
      this.autoPlayError = false
    },
    async dealSocketMsg (message) {
      const { type, content = {} } = message
      const isCurrentClassroom = (this.currentPlayItem || {}).userId == content.uid
      switch (type) {
        case SOCKET_MSG_TYPE.USER_LIST_ON_MIC:
          console.log(content, 'content.USER_LIST_ON_MIC')
          const joinStreamRoomList = (content || []).map(item => {
            item.roomId = item.uid + 'role' + item.role
            item.userRole = item.role
            item.userName = item.uname || ''
            item.roomName = item.classroomName || ''
            item.userId = item.uid
            return item
          })
          if (!this.currentPlayItem) {
            this.currentPlayItem = joinStreamRoomList[0] ? joinStreamRoomList[0] : null
          }
          this.videoList = joinStreamRoomList
          if (this.currentPlayItem) {
            this.videoList = this.videoList.map((item) => {
              if (item.roomId === this.currentPlayItem.roomId) {
                item.active = true
              } else {
                item.active = false
              }
              return item
            })
          }
          if (this.videoList.length) {
            this.initForStream(this.videoList)
          }
          break
        case SOCKET_MSG_TYPE.USER_PUBLISHED:
          console.log(content, 'content_USER_PUBLISHED')
          switch (content.mediaType) {
            case 'screen':
              const contentNew = {
                ...content,
                role: ROLE.SHARE_SCREEN,
                userRole: ROLE.SHARE_SCREEN,
                currentVideoDevice: [
                  {
                    streamId: content.streamId
                  }
                ],
                videoStreamId: content.streamId
              }
              const masterIndex = this.videoList.findIndex(v => v.userRole == ROLE.SPEAKER)
              this.videoList.splice(masterIndex + 1, 0, contentNew)
              this.initForStream(this.videoList)
              this.showForCourseScreenInListOnRight = true
              break
            case 'video':
              {
                const updateItem = this.videoList.find(i=> i.userId == content.uid) || {}
                const updateIndex = this.videoList.findIndex(i=> i.userId == content.uid)
                const newClassroom = {
                  ...updateItem,
                  currentVideoDevice: [{ ...((updateItem.currentVideoDevice || [])[0] || {}), streamId: content.streamId || '' }]
                }
                ;(updateIndex >= 0) && this.videoList.splice(updateIndex, 1, newClassroom)
                if (isCurrentClassroom) {
                  this.operationOfClickVideoListInnerItem(newClassroom)
                }
                this.initForStream(this.videoList)
              }
              break
            case 'audio':
              {
                const updateItem = this.videoList.find(i=> i.userId == content.uid) || {}
                const updateIndex = this.videoList.findIndex(i=> i.userId == content.uid)
                const newClassroom = {
                  ...updateItem,
                  currentAudioDevice: [{ ...((updateItem.currentAudioDevice || [])[0] || {}), streamId: content.streamId || '' }]
                }
                ;(updateIndex >= 0) && this.videoList.splice(updateIndex, 1, newClassroom)
                if (isCurrentClassroom) {
                  this.operationOfClickVideoListInnerItem(newClassroom)
                }
                this.initForStream(this.videoList)
              }
              break
            default:
              break
          }
          break
        case SOCKET_MSG_TYPE.USER_UNPUBLISHED:
          console.log(content, 'content_USER_UNPUBLISHED')
          switch (content.mediaType) {
            case 'screen':
              const shareScreenIndex = this.videoList.findIndex(v => v.userRole == ROLE.SHARE_SCREEN)
              this.videoList.splice(shareScreenIndex, 1)
              this.showForCourseScreenInListOnRight = false
              // 结束共享，如果正在观看课件，则默认切到教室列表的第一项，否则不变：
              if (this.lookForCourseScreen) {
                this.operationOfClickVideoListInnerItem(this.videoList[0])
              }
              break
            default:
              break
          }
          break
        case SOCKET_MSG_TYPE.USER_UPDATE:
          console.log(content, 'content.USER_UPDATE')
          const { _add, _delete } = content
          if (_add) {
            const joinUserInfo = {
              ..._add,
              userRole: _add.role,
              userName: _add.uname || '',
              roomName: _add.classroomName || '',
              userId: _add.uid
            }
            if (_add.role === ROLE.LISTENER || _add.role === ROLE.STUDENT) {
              this.videoList.push(joinUserInfo)
              this.initForStream(this.videoList)
            }
          }
          if (_delete) {
            if (_delete.role === ROLE.LISTENER) {
              const classroonDelIndex = this.videoList.findIndex(i => i.userId == _delete.uid)
              ;(classroonDelIndex >= 0) && this.videoList.splice(classroonDelIndex, 1)
              if (isCurrentClassroom) {
                this.operationOfClickVideoListInnerItem(this.videoList[0])
              }
            } else if (_delete.role === ROLE.STUDENT) {
              const studentDelIndex = this.videoList.findIndex(i => i.userId == _delete.uid)
              ;(studentDelIndex >= 0) &&  this.videoList.splice(studentDelIndex, 1)
              if (isCurrentClassroom) {
                this.operationOfClickVideoListInnerItem(this.videoList[0])
              }
            }
          }
          break
        case SOCKET_MSG_TYPE.LIVE_STATUS_UPDATE:
          console.log(content, 'content_LIVE_STATUS_UPDATE')
          if (content.status == 2) {
            this.$message.warning('下课了哦！')
            // 停止播放：
            this.lookForCourseScreen = false
            this.showForCourseScreenInListOnRight = false
            // 清空列表与当前播放教室：
            this.videoList = []
            this.currentPlayItem = null
            // 重新获取直播信息：
            this.liveClassShareLiveInfo = null
            setTimeout(async () => {
              await this.liveClassShareLive()
            }, 500)
            setTimeout(() => {
              this.$router.replace({ name: 'LiveStreamingList' })
            }, 300)
          }
          break
        case SOCKET_MSG_TYPE.LAST_INFO_DETAIL:
          console.log(content, 'content.LAST_INFO_DETAIL')
          const objReal = JSON.parse(JSON.stringify(content))
          delete objReal.autoStreamStatus
          const map = new Map()
          Object.values(objReal).forEach(item => {
            item.streamInfo.forEach(v => {
              if (v.mediaType === 'video' && v.status === 'published' && v.mediaLabel === 'app') {
                map.set(item.uid + 'mediaType' + 'video', v.streamId)
              }
              if (v.mediaType === 'audio' && v.status === 'published' && v.mediaLabel === 'app') {
                map.set(item.uid + 'mediaType' + 'audio', v.streamId)
              }
              if (v.mediaType === 'screen' && v.status === 'published' && v.mediaLabel === 'screenStream') {
                const contentNew = {
                  ...item,
                  role: ROLE.SHARE_SCREEN, 
                  userRole: ROLE.SHARE_SCREEN,
                  currentVideoDevice: [
                    {
                      streamId: v.streamId
                    }
                  ],
                  videoStreamId: v.streamId
                }
                const masterIndex = this.videoList.findIndex(v => v.userRole == ROLE.SPEAKER)
                this.videoList.splice(masterIndex + 1, 0, contentNew)
                this.initForStream(this.videoList)
              }
            })
          })
          this.videoList = this.videoList.map(item => {
            if (item.role == ROLE.STUDENT) {
              const newItem = {
                ...item,
                currentVideoDevice: [{ ...((item.currentVideoDevice || [])[0] || {}), streamId: map.get(item.uid + 'mediaType' + 'video') || '' }],
                currentAudioDevice: [{ ...((item.currentAudioDevice || [])[0] || {}), streamId: map.get(item.uid + 'mediaType' + 'audio') || '' }]
              }
              return newItem
            } else {
              return item
            }
          })
          this.initForStream(this.videoList)
          break
        case SOCKET_MSG_TYPE.VOLUME_INDICATOR:
          console.log(content, 'content_VOLUME_INDICATOR')
          const mapStreamIdVolume = new Map()
          const hasVoiceStreamIdList = (content || []).filter(item => {
            mapStreamIdVolume.set(item.streamId, item.volume)
            if (item.hasVoice) return item
          }).map(item => item.streamId)
          this.videoList = this.videoList.map(item => {
            (item.currentAudioDevice || []).forEach(v => {
              if (hasVoiceStreamIdList.includes(v.streamId)) {
                item.speaking = true
                const volume = mapStreamIdVolume.get(v.streamId)
                item.barHeightForAudio = (Math.random() + 2) * volume + '%'
              } else {
                item.speaking = false
                item.barHeightForAudio = '0%'
              }
            })
            return item
          })
          break
      }
    },
    operationOfClickButton(item) {
      if (item.disabled) return
      const { key } = item
      if (item.key === this.activeForOperationItem) {
        this.activeForOperationItem = ''
      } else {
        this.activeForOperationItem = key
      }
      switch (key) {
        case 'classroom':
          // this.dialogFlagForLCDetail = true;
          break
        case 'adjust':
          console.log('调整相应教室的机位')
          break
        case 'textInteraction':
          break
        case 'termination':
          this.dialogFlagForStopLiveCourse = true
          break
      }
    },
    async getLCDetail(liveId) {
      try {
        this.dialogLoadingForLCDetail = true
        let result = await this.$http.getLiveDetail({ liveId })
        this.dialogLoadingForLCDetail = false
        if (result.code !== 200) return this.$message.error(result.msg)
        let { rt: resultReally } = result
        if (resultReally.resultStatus !== 1)
          return this.$message.error(
            resultReally.resultMessage
              ? resultReally.resultMessage
              : '获取详情失败'
          )
        let { liveInfo } = resultReally
        let detailInfoList = JSON.parse(
          JSON.stringify(this.objectOfLCDetail.detailInfoList)
        )
        this.objectOfLCDetail.detailInfoList = detailInfoList.map((item) => {
          let { title } = item
          switch (title) {
            case '课程':
              item.firstValue = liveInfo.courseName
                ? liveInfo.courseName
                : '- -'
              item.secondValue = liveInfo.liveCode
                ? `ID：${liveInfo.liveCode}`
                : '- -'
              break
            case '类型':
              item.secondValue = `${
                liveInfo.roomNum ? liveInfo.roomNum : 0
              }间教室`
              break
            case '主讲':
              item.firstValue = liveInfo.teacherName
                ? liveInfo.teacherName
                : '- -'
              item.secondValue = liveInfo.teacherPhone
                ? liveInfo.teacherPhone
                : '- -'
              break
            case '时间':
              let startTime = liveInfo.startTime
                ? DateUtil.getTimeForDate(liveInfo.startTime)
                : ''
              let endTime = liveInfo.endTime
                ? DateUtil.getTimeForDate(liveInfo.endTime)
                : ''
              let res = `${startTime}-${endTime}`
              if (startTime && endTime) {
                if (startTime.split(' ')[0] === endTime.split(' ')[0]) {
                  let arr = startTime.split(' ')[0].split('-')
                  let arrForTimeForStart = startTime.split(' ')[1].split(':')
                  let arrForTimeForEnd = endTime.split(' ')[1].split(':')
                  res =
                    arr[0] +
                    '年' +
                    arr[1] +
                    '月' +
                    arr[2] +
                    '日 ' +
                    arrForTimeForStart[0] +
                    ':' +
                    arrForTimeForStart[1] +
                    '-' +
                    arrForTimeForEnd[0] +
                    ':' +
                    arrForTimeForEnd[1]
                }
              }
              item.firstValue = res
              break
          }
          return item
        })
        let teachRoomList = resultReally.teachRoom
          ? [{ ...resultReally.teachRoom, roomType: 1 }]
          : []
        let watchRoomList = (resultReally.watchRoom || []).map((item) => {
          return {
            ...item,
            roomType: 2,
          }
        })
        this.objectOfLCDetail.roomList = [...teachRoomList, ...watchRoomList]
      } catch (err) {
        console.log(err)
      }
    },
    hideMaskForStopLiveCourse() {
      this.dialogFlagForStopLiveCourse = false
    },
    operationForStopLiveCourseItem(stopLiveCourseOperationItem) {
      let { title } = stopLiveCourseOperationItem
      switch (title) {
        case '继续终止':
          this.stopLiveCourseContinue()
          break
        case '撤销操作':
          this.hideMaskForStopLiveCourse()
          this.stopReason = ''
          this.setForActiveForOperationItem('')
          break
      }
    },
    // 继续终止：
    async stopLiveCourseContinue() {
      try {
        if (!this.stopReason) {
          // 设置抖动：
          this.stopReasonHasAnimateShakeX = true
          setTimeout(() => {
            this.stopReasonHasAnimateShakeX = false
          }, 500)
          return this.$message.warning('请输入终止直播的原因')
        }
        // 与后端讨论该传啥：
        let { liveId } = this.$route.query
        let params = {
          mainLiveId: liveId,
          reason: this.stopReason,
        }
        this.dialogLoadingForStopLiveCourse = true
        let result = await this.$http.stopLive(params)
        this.dialogLoadingForStopLiveCourse = false
        if (result.code !== 200) return this.$message.error(result.msg)
        let { rt: resultReally } = result
        if (resultReally.resultStatus !== 1)
          return this.$message.error(
            resultReally.resultMessage
              ? resultReally.resultMessage
              : '终止直播失败'
          )
        // 需要通过终止的类型（是下课还是退课），进而跳转至相应的页面
        this.$message.success('终止直播成功')
        this.hideMaskForStopLiveCourse()
        this.stopReason = ''
        this.setForActiveForOperationItem('')
        // code： 1下课，2退课
        // 针对下课还是上课，这里不用做判断了，因为会发指令，4004或者4007
      } catch (err) {
        console.log(err)
      }
    },
    // 播放课件：
    operationOfClickCourseScreen() {
      this.lookForCourseScreen = true
      // 设置当前播放教室（播放课件的时候需要展示主讲的画面）
      this.currentPlayItem = this.videoList.find(
        (item) => item.userRole === ROLE.SPEAKER
      )
      // 设置高亮选中效果：
      this.videoList = this.videoList.map((item) => {
        item.active = false
        return item
      })
      this.setForActiveForOperationItem('')
      this.disposeForAdjustDisabled(true)
      // 由于后面加了共享屏幕的声音，所以刷新不会自动播放了，这里加一个播放：
      const idForCourseScreenOnLeftDOM = document.querySelector('#idForCourseScreenOnLeft')
      if (idForCourseScreenOnLeftDOM) {
        idForCourseScreenOnLeftDOM.play()
      }
    },
    // 播放教室画面：
    operationOfClickVideoListInnerItem(item) {
      this.lookForCourseScreen = false
      // 设置当前播放教室
      this.currentPlayItem = item
      console.log(this.currentPlayItem,'currentPlayItemcurrentPlayItemcurrentPlayItem')
      // 设置高亮选中效果：
      this.videoList = this.videoList.map((item) => {
        if (item.roomId === this.currentPlayItem.roomId) {
          item.active = true
        } else {
          item.active = false
        }
        return item
      })
      this.setForActiveForOperationItem('')
      // this.disposeForAdjustDisabled(false)
      // 默认要置灰：
      this.disposeForAdjustDisabled(true)
    },
    lookForNetworkInfo() {
      this.networkInfoShow = !this.networkInfoShow
    },
    setForActiveForOperationItem (key) {
      this.activeForOperationItem = key
    },
    // 设置球控不可操作：
    disposeForAdjustDisabled (flagForDisabled) {
      this.operationList = this.operationList.map(item => {
        const { key } = item
        if (key === 'adjust') {
          item.img = flagForDisabled ? item.imgGray : item.imgWhite
          item.color = flagForDisabled ? '#555B62 ' : '#FFF'
          item.disabled = flagForDisabled
        }
        return item
      })
    },
    // 添加调试中这个状态，所以需要获取新的详情：
    getLiveDetailForAPP(liveId) {
      return new Promise(async (resolve, reject) => {
        try {
          // const result = await this.$http.getLiveDetailForAPP({ liveId })
          // 替换为新接口：
          const result = await this.$http.getLiveInfoGlobalMSC2({ liveId })
          if (result.code !== 200) return reject(result.msg)
          const { rt: resultReally } = result
          if (resultReally.resultStatus !== 1) return this.$message.error(resultReally.resultMessage)
          resolve(result.rt)
        } catch (err) {
          console.log(err)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@mixin dialogTitle($color) {
  width: 100%;
  height: 60px;
  line-height: 60px;
  font-weight: bold;
  color: $color;
  font-size: 16px;
  border-radius: 10px 10px 0 0;
  padding: 0 30px;
  border-bottom: 1px solid #e7e7e7;
}
@mixin verticalAndCrosswiseCenter {
  display: flex;
  justify-content: center;
  align-items: center;
}
.supervision_course_container {
  width: 100%;
  height: 100vh;
  background-color: #000;
  position: relative;
  // background-image: radial-gradient(at center top, rgba(82, 135, 233, 0.8) -400px, #000000 400px);
  text-align: left;
  display: flex;
  flex-direction: column;
  .supervision_course_container_header {
    width: 100%;
    height: 100px;
    background-color: #0E111C;
    position: relative;
    border-bottom: 2px solid #090d1b;
    .supervision_course_container_header_status_and_time {
      width: auto;
      height: 50px;
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
    }
    .supervision_course_container_header_title_module {
      width: 600px;
      height: 100px;
      position: absolute;
      left: 50%;
      top: 0;
      transform: translateX(-50%);
      img {
        width: 100%;
        height: 100%;
        display: block;
      }
    }
    .supervision_course_container_header_right_module {
      width: auto;
      height: inherit;
      padding: 0 16px;
      position: absolute;
      right: 0;
      top: 0;
      display: flex;
      align-items: center;
    }
  }
  .supervision_course_container_body {
    width: 100%;
    height: calc(100vh - 166px);
    background-color: #0b1321;
    display: flex;
    padding: 16px 0;
    position: relative;
    .supervision_course_container_body_left {
      flex: 1;
      margin-left: 16px;
      position: relative;
      .supervision_course_container_body_left_inner_for_screen_stream,
      .supervision_course_container_body_left_inner_for_class_of_outer {
        width: 100%;
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: #000;
        overflow: hidden;
      }
      .supervision_course_container_body_left_inner_for_screen_stream {
        #idForCourseScreenOnLeft {
          width: 100% !important;
          height: 100% !important;
          position: absolute;
          top: 0;
          left: 50%;
          transform: translateX(-50%);
        }
      }
      .supervision_course_container_body_left_inner_for_class_of_outer {
        @include verticalAndCrosswiseCenter();
        #videoForClassroomOnLeft {
          width: 100% !important;
          height: 100% !important;
          position: absolute;
          top: 0;
          left: 50%;
          transform: translateX(-50%);
        }
        #audioForClassroomOnLeft {
          position: absolute;
          left: -1000px;
          top: -1000px;
        }
      }
      .play_explain_for_box {
        position: absolute;
        bottom: 0px;
        left: 0px;
        font-size: 16px;
        padding: 0 16px;
        color: #fff;
        background-color: rgba(0, 0, 0, 0.7);
        z-index: 2;
        width: 100%;
        height: 56px;
        line-height: 56px;
        background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.6) 100%);
      }
      .video_empty_container {
        @include verticalAndCrosswiseCenter();
        flex-direction: column;
        font-size: 16px;
        color: #ddd;
        user-select: none;
        background-color: #000;
        .iconfont {
          font-size: 40px;
          margin-bottom: 10px;
        }
      }
    }
    .supervision_course_container_body_right {
      width: 320px;
      height: 100%;
      position: relative;
      overflow: hidden;
      .supervision_course_container_body_right_for_video {
        width: calc(100% + 30px);
        height: 100%;
        padding: 0 16px;
        overflow-y: auto;
        display: flex;
        justify-content: flex-start;
        align-items: center;
      }
      .supervision_course_container_body_right_inner_item {
        width: 288px;
        height: 162px;
        margin-bottom: 16px;
        cursor: pointer;
        transition: all 0.3s ease;
        overflow: hidden;
        position: relative;
        background: #000;
        border-radius: 6px;
        &:nth-last-child(1) {
          margin-bottom: 0px;
        }
        &.active {
          border: 3px solid #fb6f33;
        }
        .supervision_course_container_body_right_inner_item_for_video {
          width: 100%;
          height: 100%;
          position: relative;
          &.course_screen_in_list_on_right_outer {
            #idForCourseScreenInListOnRight {
              width: 100% !important;
              height: 100% !important;
              position: absolute;
              top: 0;
              left: 50%;
              transform: translateX(-50%);
              // object-fit: fill;
            }
          }
          &.classroom_in_list_on_right_outer {
            video {
              width: 100% !important;
              height: 100% !important;
              position: absolute;
              top: 0;
              left: 50%;
              transform: translateX(-50%);
              // object-fit: fill;
            }
            audio {
              position: absolute;
              left: -5000px;
              top: -5000px;
            }
          }
        }
        .play_explain_for_box {
          position: absolute;
          bottom: 0px;
          left: 0px;
          font-size: 14px;
          padding: 0 12px;
          color: #fff;
          width: 100%;
          height: 36px;
          background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.6) 100%);
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
      }
      .live_detail_container {
        width: 308px;
        height: calc(100% + 16px);
        background-color: #0E111C;
        position: absolute;
        right: 0;
        top: -16px;
        color: #fff;
        padding: 12px 14px;
        overflow-y: auto;
        .live_detail_container_title {
          width: 100%;
          height: 60px;
          line-height: 65px;
          border-bottom: 1px solid #424653;
          font-weight: bold;
        }
        .live_detail_container_base_info_title,
        .live_detail_container_for_teacher_title,
        .live_detail_container_for_student_title {
          width: 100%;
          height: 30px;
          line-height: 30px;
          font-size: 14px;
          padding-left: 8px;
          position: relative;
          margin-top: 10px;
          &:before {
            content: '';
            width: 3px;
            height: 16px;
            background-color: #3a82ff;
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
          }
        }
        .live_detail_container_base_info {
          color: #ececed;
          border-bottom: 1px solid #424653;
          .live_detail_container_base_info_title {
          }
          .live_detail_container_base_info_body {
            padding: 10px;
            padding-top: 0px;
            font-size: 12px;
            .live_detail_container_base_info_body_item {
              display: flex;
              align-items: center;
              padding: 5px 0;
              .live_detail_container_base_info_body_item_title {
              }
              .live_detail_container_base_info_body_item_body {
                flex: 1;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }
            }
          }
        }
        .live_detail_container_for_teacher {
          margin-bottom: 20px;
          color: #ececed;
          .live_detail_container_for_teacher_title {
            margin-bottom: 10px;
          }
          .live_detail_container_for_teacher_body {
            width: 100%;
            height: auto;
            background-color: #223961;
            border-radius: 5px;
            padding: 10px;
          }
        }
        .live_detail_container_for_student {
          .live_detail_container_for_student_title {
            margin-bottom: 10px;
          }
          .live_detail_container_for_student_body {
            width: 100%;
            height: auto;
            background-color: #223961;
            border-radius: 5px;
            padding: 10px;
          }
        }
        .body_item {
          &.body_item_for_student {
            margin-bottom: 20px;
          }
          &.body_item_for_student:nth-last-of-type(1) {
            margin-bottom: 0;
          }
          .body_item_title {
            font-size: 14px;
          }
          .body_item_body {
            font-size: 12px;
            .body_item_body_management,
            .body_item_body_maintain {
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              margin: 5px 0;
            }
            .body_item_body_management {
            }
            .body_item_body_maintain {
              margin-bottom: 0;
            }
          }
        }
        .live_detail_container_for_teacher_body_empty,
        .live_detail_container_for_student_body_empty {
          width: 100%;
          height: 50px;
          background-color: #223961;
          border-radius: 5px;
          @include verticalAndCrosswiseCenter();
          color: #AAA;
          font-size: 14px;
        }
      }
      .textInteraction_container {
        width: 308px;
        height: 100%;
        background-color: #0E111C;
        position: absolute;
        right: 0;
        top: 0;
      }
    }
    .supervision_course_container_body_right_top_module {
      width: 308px;
      height: 16px;
      background-color: #0E111C;
      position: absolute;
      right: 0;
      top: 0;
    }
  }
  .supervision_course_container_footer {
    width: 100%;
    height: 66px;
    color: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #0E111C;
    .supervision_course_container_footer_left_for_name {
      font-size: 20px;
      padding-left: 25px;
    }
    .supervision_course_container_footer_right_for_operation {
      display: flex;
      width: auto;
      height: 100%;
      padding-right: 16px;
      .supervision_course_container_footer_right_for_operation_item {
        width: 88px;
        height: 100%;
        cursor: pointer;
        font-size: 12px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        &.class_for_disabled {
          cursor: not-allowed;
          &:hover {
            background-color: #0F111C;
          }
          &.active {
            background-color: #0F111C;
          }
        }
        .iconfont_icon {
          width: 24px;
          height: 24px;
          display: block;
        }
        .iconfont_text {
          margin-top: 3px;
        }
        &:hover {
          background-color: #2c3038;
        }
        &.active {
          background-color: #2c3038;
        }
      }
    }
  }
}
.empty_for_class_rooom_list {
  width: 100%;
  height: 100%;
  background-color: #000;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  flex-direction: column;
  .iconfont {
    font-size: 50px;
    margin-bottom: 10px;
  }
}
// 终止直播：
.dialog_inner_container_for_stop_live_course {
  position: relative;
  .dialog_inner_container_for_stop_live_course_header {
    @include dialogTitle(#fe7c14);
    text-align: center;
    border-bottom: none;
    background-color: #353744;
    line-height: 70px;
    font-size: 20px;
    border-radius: 8px 8px 0 0;
  }
  .dialog_inner_container_for_stop_live_course_body {
    padding: 5px 35px 24px;
    background-color: #353744;
    .dialog_inner_container_for_stop_live_course_body_title {
      font-size: 14px;
      color: #D3D4D7;
    }
    .dialog_inner_container_for_stop_live_course_body_content {
      width: 100%;
      height: 130px;
      border: 1px solid #3B7AEE;
      border-radius: 8px;
      margin-top: 20px;
      padding: 16px;
      background-color: #484A56;
      textarea {
        width: 100%;
        height: 100% !important;
        border: none;
        outline: none;
        resize: none;
        background-color: #484A56;
        color: #8D8FA0;
        font-size: 12px;
        color: #FFF;
      }
      // 改变placeholder的颜色：兼容性处理
      textarea::-webkit-input-placeholder {
        /* WebKit browsers */
        color: #8D8FA0;
        font-family: PingFangSC-Regular, PingFang SC;
        font-size: 12px;
      }
      textarea:-moz-placeholder {
        /* Mozilla Firefox 4 to 18 */
        color: #8D8FA0;
        font-family: PingFangSC-Regular, PingFang SC;
        font-size: 12px;
      }
      textarea::-moz-placeholder {
        /* Mozilla Firefox 19+ */
        color: #8D8FA0;
        font-family: PingFangSC-Regular, PingFang SC;
        font-size: 12px;
      }
      textarea:-ms-input-placeholder {
        /* Internet Explorer 10+ */
        color: #8D8FA0;
        font-family: PingFangSC-Regular, PingFang SC;
        font-size: 12px;
      }
    }
  }
  .dialog_inner_container_for_stop_live_course_footer {
    display: flex;
    padding: 0 35px;
    padding-bottom: 64px;
    justify-content: space-between;
    background-color: #353744;
    border-radius: 0 0 8px 8px;
    .dialog_inner_container_for_stop_live_course_footer_inner_item {
      width: 152px;
      height: 44px;
      @include verticalAndCrosswiseCenter();
      border-radius: 8px;
      cursor: pointer;
      user-select: none;
      &.stop_live_course_continue {
        &:hover {
          background-color: rgba(255, 255, 255, .1) !important;
        }
        &:active {
          background-color: transparent !important;
        }
      }
      &.stop_live_course_cancel {
        box-shadow: #3982FF;
        &:hover {
          background-color: #2563ce !important;
        }
        &:active {
          background-color: #3982FF !important;
        }
      }
    }
  }
}
.loading_mask {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  @include verticalAndCrosswiseCenter();
  background-color: rgba(255, 255, 255, 0.7);
  cursor: not-allowed;
}
</style>
